import { render, staticRenderFns } from "./H5template.vue?vue&type=template&id=945bd302&scoped=true&"
import script from "./H5template.vue?vue&type=script&lang=js&"
export * from "./H5template.vue?vue&type=script&lang=js&"
import style0 from "./H5template.vue?vue&type=style&index=0&id=945bd302&prod&lang=css&"
import style1 from "./H5template.vue?vue&type=style&index=1&id=945bd302&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945bd302",
  null
  
)

export default component.exports